import FooterResult from './FooterResult';
export default FooterResult;
